<script lang="ts">
    export let onIntersecting: () => void

    function observe(lastMarker: HTMLDivElement) {

        const lastMarkerOptions = {
            rootMargin: '0px 0px 0px 0px',
            threshold: 0,
        }
        const lastMarkerObserver = new IntersectionObserver(loadMoreSentences, lastMarkerOptions);
        lastMarkerObserver.observe(lastMarker)

        function loadMoreSentences(entries: IntersectionObserverEntry[]) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    onIntersecting()
                }
            })
        }

        return {
            destroy() {
                lastMarkerObserver.disconnect()
            }
        }
    }

</script>

<div id="last-marker"
     use:observe
></div>

<style>
    #last-marker {
        height: 1px;
        /*background: #638ca6;*/
    }
</style>